import { ComplexEnumItem } from '../../utils/complexEnum/ComplexEnumItem'

export class FrequencyItem<
  ID extends Lowercase<string>,
  Name extends string,
  Label extends string,
  Type extends string,
  Key extends string
> extends ComplexEnumItem<ID> {
  readonly label: Label
  readonly name: Name
  readonly type: Type
  readonly key: Key
  constructor({
    id,
    label,
    name,
    type,
    key,
  }: Pick<
    FrequencyItem<ID, Name, Label, Type, Key>,
    'id' | 'name' | 'label' | 'type' | 'key'
  >) {
    super(id)
    this.label = label
    this.name = name
    this.type = type
    this.key = key
  }
}
